import { render, staticRenderFns } from "./OrganizationChartModal.vue?vue&type=template&id=1dec7f3c&scoped=true&"
import script from "./OrganizationChartModal.vue?vue&type=script&lang=js&"
export * from "./OrganizationChartModal.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationChartModal.vue?vue&type=style&index=0&id=1dec7f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec7f3c",
  null
  
)

export default component.exports